import { render, staticRenderFns } from "./vue-accordion.vue?vue&type=template&id=be8c0f76"
import script from "./vue-accordion.vue?vue&type=script&lang=js"
export * from "./vue-accordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@5.2.7_webpack@5.111.0__lodash@4.18.1_vu_d5766d53fa3af55ecda13d456ae73cbe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/phuongle/Documents/Accolade/AW-260/accoladewines-branded-sites-astro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be8c0f76')) {
      api.createRecord('be8c0f76', component.options)
    } else {
      api.reload('be8c0f76', component.options)
    }
    module.hot.accept("./vue-accordion.vue?vue&type=template&id=be8c0f76", function () {
      api.rerender('be8c0f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/vue-accordion.vue"
export default component.exports